function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m6.78 13.56a6.78 6.78 0 1 1 6.78-6.78 6.78 6.78 0 0 1 -6.78 6.78zm.88-5.5v-5a.66.66 0 0 0 -.66-.65h-.44a.65.65 0 0 0 -.65.65v5l-1.98-2.06a.66.66 0 0 0 -.93 0l-.3.3a.65.65 0 0 0 0 .93l3.63 3.63a.66.66 0 0 0 .92 0l3.63-3.63a.65.65 0 0 0 0-.93l-.3-.3a.65.65 0 0 0 -.93 0z",
  fill: "#202144"
});

var SvgBtDownload = function SvgBtDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13.56 13.56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBtDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bt-download.3bef9459.svg";
export { ForwardRef as ReactComponent };